import {createContext, useContext} from "react";

import {CollapsiblePanelContextValue} from "@/components/collapsiblePanel/CollapsiblePanel.types.ts";

export const CollapsiblePanelContext = createContext<CollapsiblePanelContextValue | null>(null);

export const useCollapsiblePanelContext = (): CollapsiblePanelContextValue => {
  const context = useContext(CollapsiblePanelContext);
  if (!context) {
    throw new Error("useCollapsiblePanelContext must be used within a CollapsiblePanel");
  }
  return context;
};
